import React from 'react';

import './Conseil.css';
import './Conseil.mobile.css';


const Conseil = () => {

    const sections = [
        {
            id: "01",
            category: "AUDIT",
            title: "Diagnostic et Analyse Impartiale",
            points: [
                {
                    label: "Audit des processus",
                    description:
                        "Identification des frictions et goulots d'étranglement."
                },
                {
                    label: "Dette Technique",
                    description:
                        "Analyse des interdépendances au sein de votre stack."
                },
                {
                    label: "Analyse de risques",
                    description:
                        "Détection précoce des vulnérabilités critiques."
                }
            ]
        },
        {
            id: "02",
            category: "STRATÉGIE",
            title: "Aide à la Décision",
            points: [
                {
                    label: "Architecture",
                    description:
                        "Orientation vers des structures scalables et pérennes."
                },
                {
                    label: "Roadmap",
                    description:
                        "Planification des étapes pour une transition fluide."
                },
                {
                    label: "MVP / PoC",
                    description:
                        "Prototypage rapide pour tester vos idées sans risque."
                }
            ]
        },
        {
            id: "03",
            category: "AGILITÉ",
            title: "Optimisation Opérationnelle",
            points: [
                {
                    label: "Pipelines IA",
                    description:
                        "Conception de workflows pour libérer vos ressources."
                },
                {
                    label: "Standardisation",
                    description:
                        "Optimisation des cycles Dev et des pratiques DevOps."
                },
                {
                    label: "Interopérabilité",
                    description:
                        "Communication sans friction (API, ERP, tiers)."
                }
            ]
        },
        {
            id: "04",
            category: "SAVOIR",
            title: "Transmission et Coaching",
            points: [
                {
                    label: "Accompagnement",
                    description:
                        "Coaching des équipes sur les nouvelles méthodologies."
                },
                {
                    label: "Vulgarisation",
                    description:
                        "Traductions techniques pour décisions stratégiques."
                },
                {
                    label: "Autonomie",
                    description:
                        "Documentation complète et assistance continue."
                }
            ]
        }
    ];


    return (

        <section
            className="conseil-section"
            aria-labelledby="conseil-title"
        >

            <div className="conseil-container">


                {/* =================================================
                    HERO
                    ================================================= */}

                <header className="conseil-hero">

                    <h1
                        id="conseil-title"
                        className="conseil-title"
                    >

                        <span className="conseil-title-primary">
                            CONSEIL
                        </span>

                        <span className="conseil-title-accent">
                            & EXPERTISE
                        </span>

                    </h1>


                    <div className="conseil-hero-intro">

                        <span className="conseil-hero-intro-label">
                            APPROCHE
                        </span>


                        <p className="conseil-hero-intro-text">

                            Transformer vos systèmes d'information en

                            <strong>
                                {" "}vecteurs de croissance{" "}
                            </strong>

                            concrets.

                        </p>

                    </div>

                </header>


                {/* =================================================
                    MAIN COMPOSITION
                    ================================================= */}

                <div className="conseil-layout">


                    {/* =================================================
                        MANIFESTO
                        ================================================= */}

                    <aside className="conseil-manifesto">

                        <div className="conseil-manifesto-top">

                            <span className="conseil-manifesto-kicker">
                                VISION
                            </span>


                            <p className="conseil-manifesto-title">
                                Décider avec plus de clarté.
                            </p>


                            <div className="conseil-manifesto-rule" />


                            <p className="conseil-manifesto-description">
                                Une expertise technique ne crée de valeur
                                que lorsqu'elle permet de prendre de meilleures
                                décisions, plus rapidement et avec moins de risque.
                            </p>

                        </div>


                        <div className="conseil-manifesto-footer">

                            <span className="conseil-manifesto-footer-label">
                                OBJECTIF
                            </span>


                            <p>
                                Sécuriser vos actifs, structurer vos choix
                                et accélérer les décisions qui comptent.
                            </p>

                        </div>

                    </aside>


                    {/* =================================================
                        CARDS

                        Desktop : grille
                        Mobile : carrousel horizontal
                        ================================================= */}

                    <div
                        className="conseil-cards-track"
                        role="region"
                        aria-roledescription="carrousel"
                        aria-label="Domaines de conseil et expertise"
                    >

                        {sections.map((section) => (

                            <article
                                key={section.id}
                                className="conseil-card"
                            >


                                <header className="conseil-card-header">

                                    <span className="conseil-card-number">
                                        {section.id}
                                    </span>


                                    <span className="conseil-card-category">
                                        {section.category}
                                    </span>

                                </header>


                                <div className="conseil-card-content">

                                    <h2 className="conseil-card-title">
                                        {section.title}
                                    </h2>


                                    <div className="conseil-card-rule" />


                                    <div className="conseil-card-points">

                                        {section.points.map(
                                            (
                                                point,
                                                index
                                            ) => (

                                                <div
                                                    key={`${section.id}-${index}`}
                                                    className="conseil-card-point"
                                                >

                                                    <span className="conseil-card-point-label">
                                                        {point.label}
                                                    </span>


                                                    <p className="conseil-card-point-description">
                                                        {point.description}
                                                    </p>

                                                </div>

                                            )
                                        )}

                                    </div>

                                </div>


                                <footer className="conseil-card-footer">

                                    <span>
                                        ADVISORY / {section.id}
                                    </span>


                                    <span>
                                        {section.category}
                                    </span>

                                </footer>

                            </article>

                        ))}

                    </div>

                </div>


                {/* =================================================
                    FINAL STATEMENT
                    Masqué sur mobile via CSS
                    ================================================= */}

                <footer className="conseil-final">

                    <span className="conseil-final-label">
                        EXPERTISE CIBLÉE
                    </span>


                    <p className="conseil-final-text">
                        Apporter la bonne expertise au bon moment
                        pour sécuriser vos actifs et renforcer
                        vos décisions stratégiques.
                    </p>

                </footer>


            </div>

        </section>

    );
};


export default Conseil;